export default "__VITE_ASSET__DKUWpUse__"